import React, { useState, useRef, useEffect } from "react";
import { Plus, ChevronDown} from "lucide-react";

import teamIcon from "../../../assets/images/icons/team-icon.svg";
import refIcon from "../../../assets/images/icons/ref-icon.svg";
import adminIcon from "../../../assets/images/icons/admin-icon.svg";
import { MODAL_TYPES } from "../constants";

/**
 * Header Component
 * Breadcrumbs, title, and Add button with dropdown
 */
const Header = ({ activeTab, onOpenAddModal, canManageParticipants = true }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleAddClick = (type) => {
    onOpenAddModal(type);
    setShowDropdown(false);
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-[22px] font-normal text-[#FEFCEB]">Participants</h1>
      </div>

      {/* Add Button & Dropdown */}
      {canManageParticipants && (
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="bg-[#00E7FF] hover:opacity-50 text-[#021529] text-[15px] font-medium px-4 py-2 rounded-full gap-1 flex items-center transition-all active:scale-95"
        >
          Add
          <ChevronDown
            size={19}
            color="#021529"  // or use className="text-[#a1b5d8]"
            className={`transition-transform duration-200 mt-0.5 shrink-0 ${showDropdown ? 'rotate-180' : ''}`}
          />
        </button>

        {showDropdown && (
          <div className="absolute right-0 top-full mt-2 w-40 bg-[#000F1F] border border-[#192634] rounded-2xl shadow-xl z-50 overflow-hidden">
            <DropdownItem
              onClick={() => handleAddClick(MODAL_TYPES.TEAM)}
              label="Invite Team"
              icon={teamIcon}
              hasBorder
            />
            <DropdownItem
              onClick={() => handleAddClick(MODAL_TYPES.REFEREE)}
              label="Referee"
              icon={refIcon}
              hasBorder
            />
            <DropdownItem
              onClick={() => handleAddClick(MODAL_TYPES.ADMIN)}
              label="Administrator"
              icon={adminIcon}
            />
          </div>
        )}
      </div>
      )}
    </div>
  );
};

const DropdownItem = ({ onClick, label, icon, hasBorder = false }) => (
  <button
    onClick={onClick}
    className={`w-full text-left px-4 py-3 text-[#FEFCEB] hover:bg-[#0D1B29] transition-colors text-sm font-medium flex items-center gap-1.5 ${
      hasBorder ? "border-b border-[#192634]" : ""
    }`}
  >
    {icon && <img src={icon} alt="" className="w-5 h-5" />}
    {label}
  </button>
);

export default Header;
